import * as taskName from './task-name'
import * as processUI from '../../process-ui'
import { createUIDefinition } from '../default-task-definition'
import { ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT } from '../../../../anamnesis/state/anamnesis/const'
import { selectProcessContext } from '../../../state/instance-detail/selector'
import { createValidationMessage } from '../../../../validation/create-validation-message'
import { selectOrderedImageVersionList } from '../../../../customer/state/image/selector'
import { selectMedicalAssessment } from '../../../../anamnesis/state/anamnesis/selector'
import { selectStoreList } from "../../../../globals/state/selector";

export default createUIDefinition({
    taskName: taskName.MEDICAL_ASSESSMENT,
    overwriteWidget: true,
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.CUSTOMER_CONTACT_WIDGET,
        },
        {
            component: processUI.ANAMNESIS_LIST_WIDGET_CONTAINER,
            widgetProps: {
                excludeTemplateKeyList: [
                    ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT,
                ],
            },
        },
        {
            component: processUI.ANAMNESIS_EDIT_WIDGET_CONTAINER,
            widgetProps: {
                templateKey: ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT,
            },
        },
        {
            component: processUI.PATIENT_IPR_WISHES_WIDGET,
            widgetProps: {
                readOnly: false,
                templateKey: ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT,
                taskName: 'medical_assessment',
            },
        },
        {
            component: processUI.ATTACHMENT_AGREEMENT_WIDGET,
            readOnly: false,
        },
        {
            component: processUI.COMMENT_LIST,
        },
        {
            component: processUI.CUSTOMER_IMAGE_UPLOAD_WIDGET,
            widgetProps: {
                skipImages: [
                    'lower-row-of-teeth',
                    'upper-row-with-aligner',
                    'lower-row-with-aligner',
                ],
            },
        },
        {
            component: processUI.PATIENT_SCANNED_WIDGET,
        },

        {
            component: processUI.PRE_TREATMENT_REASON_WIDGET_CONTAINER,
        },
        {
            component: processUI.TRANSITION_LIST_WIDGET_CONTAINER,
        },
    ],
    taskValidatorSelector: [
        selectProcessContext,
        selectOrderedImageVersionList,
        selectMedicalAssessment,
        selectStoreList,
    ],
    taskValidator: (
        task,
        processInstance,
        taskName,
        eventName,
        context,
        imageVersionList,
        medAssessment,
        stores,
    ) => {
        const messageList = []

        const isPretreatmentNeeded = eventName === 'pretreatment_needed'
        const canNotBeTreated = eventName === 'cannot_be_treated'
        const isMedicalCheckDone = eventName === 'medical_check_done'
        const isImageNotComplete =
            (!!imageVersionList.other &&
                Object.keys(imageVersionList).length < 9) ||
            Object.keys(imageVersionList).length < 8

        const store = stores.find(s => s.technicalName === context.store);
        const isIPRProviderStore = store.iprProvider;
        const isAttachmentProviderStore = store.attachmentAvailable;

        const iprAgreementMade = typeof medAssessment.formData.iprAgreed === "boolean";
        const attachmentDecisionMade = typeof medAssessment.formData.attachmentAgreed === "boolean";

        if (isIPRProviderStore && !iprAgreementMade) {
            messageList.push(
                createValidationMessage(
                    'Please add the patient agreement for IPR before proceeding.',
                    'iprAgreed',
                ),
            )
        }

        if (isAttachmentProviderStore && !attachmentDecisionMade) {
            messageList.push(
                createValidationMessage(
                    'Please add the patient agreement for Attachment before proceeding.',
                    'attachmentAgreed',
                ),
            )
        }

        if (canNotBeTreated && !context.cannotBeTreatedReason) {
            messageList.push(
                createValidationMessage(
                    "Please add the reason for 'cannot be treated' before proceeding.",
                    'cannot_be_treated',
                ),
            )
        }
        if (isPretreatmentNeeded && !context.preTreatmentReason) {
            messageList.push(
                createValidationMessage(
                    "Please add the reason for 'pretreatment' before proceeding.",
                    'preTreatmentReason',
                ),
            )
        }
        if (context.patientScanned === undefined) {
            messageList.push(
                createValidationMessage(
                    'Please select, if you have scanned the customer.',
                    'patientScanned',
                ),
            )
        }
        if ((context.patientScanned === false) && !canNotBeTreated) {
            messageList.push(
                createValidationMessage(
                    'With patient scanned No , process can only proceed with "cannot be treated"',
                    'patientScanned',
                ),
            )
        }
        if (isImageNotComplete && !canNotBeTreated) {
            messageList.push(
                createValidationMessage(
                    'Please take all pictures first.',
                    'validateAllPhotosUploaded',
                ),
            )
        }

        if (isMedicalCheckDone && (context.preTreatmentReason || context.cannotBeTreatedReason)) {
            messageList.push(
                createValidationMessage(
                    'Please remove the reason for \'pretreatment\' before proceeding.',
                    'validateMedicalCheckDone',
                ),
            )
        }
        return messageList
    },
})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/in-shop-scan/medical-assessment.js